module.exports = __webpack_public_path__ + "static/media/logo.fff60da9.png";